export default __webpack_public_path__ + "static/media/cnn_kr_alph_a2.bb3b493a.mp3";